import React from 'react';
import styles from './Footer.module.css';

const LINKS = [
  { label: 'Curriculum', href: '#curriculum' },
  { label: 'Outcomes',   href: '#outcomes' },
  { label: 'Mentor',     href: '#mentor' },
  { label: 'Reviews',    href: '#reviews' },
  { label: 'FAQ',        href: '#faq' },
  { label: 'Enroll',     href: '#enroll' },
  { label: 'Privacy Policy',   href: '#' },
  { label: 'Refund Policy',    href: '#' },
  { label: 'Contact Us',       href: 'mailto:hello@digimint.com' },
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.top}>
          <div className={styles.brand}>
            <div className={styles.logo}>digi<span>mint</span></div>
            <p className={styles.desc}>
              Performance marketing education for the next generation of digital professionals.
              Based in Pune, accessible everywhere.
            </p>
            
          </div>

          <div className={styles.links}>
            <div className={styles.linksCol}>
              <div className={styles.colTitle}>Course</div>
              {LINKS.slice(0, 6).map(l => (
                <a key={l.href + l.label} href={l.href} className={styles.link}>{l.label}</a>
              ))}
            </div>
            <div className={styles.linksCol}>
              <div className={styles.colTitle}>Company</div>
              {LINKS.slice(6).map(l => (
                <a key={l.href + l.label} href={l.href} className={styles.link}>{l.label}</a>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.bottom}>
          <p>© {new Date().getFullYear()} Digimint. All rights reserved.</p>
          <p>Performance Marketing Course · Pune, Maharashtra, India · Online &amp; Offline</p>
          
        </div>
      </div>
    </footer>
  );
}
